module.exports = __webpack_public_path__ + "img/cash-assist.b5f1a5ea.svg";